jQuery(document).ready(function($) {
	new WOW().init();
	
	$(window).scroll(function() {
	    if ($(this).scrollTop() > 40) { // this refers to window
	        $('.header').addClass('scroll');
	    } else {
	    	 $('.header').removeClass('scroll');
	    }
	});

	$('.scroll-top').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    });

    $('.mobile-menu-trigger').click(function() {
	    $('.header-right').toggleClass( "active" );
	});

	$('#posts-list .container .categories p').click(function() {
	    $('#posts-list .container .categories-list').toggleClass( "active" );
	    $(this).toggleClass( "active" );
	});
	
	$('.enquiry-trigger').click(function() {
	    $('#form-bar').addClass( "active" );
	});

	$('#form-bar .cross').click(function() {
	    $('#form-bar').removeClass( "active" );
	});
	
	$('header .row .header-right .top .mobile-nav .mobile-menu-trigger .cross').click(function() {
	    $('header .row .header-right .bottom nav > ul > li.menu-item-has-children .sub-menu').removeClass( "active" );
	});

	$( '#menu-header-nav li:has(.sub-menu)' ).doubleTapToGo();


    function submenu_reveal() {
        if($(window).width() < 992) {
			$('header .row .header-right .bottom nav > ul > li.menu-item-has-children').click(function() {
			    $(this).find('.sub-menu').addClass( "active" );
			});
        } else {
      		$('header nav .sub-menu').removeClass('active');
        }
    }

	/* ====================== Enable functions on page load ======================  */
    submenu_reveal();

	/* ====================== Resize run functions ======================  */
	$(window).resize(function(){
	    submenu_reveal();
	})


	/* ====================== About accordion ======================  */

	$('.accordion').find('.accordion-toggle').click(function(){
    	$(this).next().slideToggle();
    	$(this).toggleClass('open');
    	$(".accordion-content").not($(this).next()).slideUp();
    	$(".accordion-toggle").not($(this)).removeClass('open');

        $('html, body').animate({
	      scrollTop: $(this).parent().prev().offset().top - 40
	    }, 1000)
    });
	  
}); 
